<template>
  <div>
    <div class="report-query-section">
      <div class="query-container">
        <h3 class="query-title">报告编号查询</h3>
        <div class="query-form">
          <input 
            type="text" 
            v-model="evaluationNumber" 
            style="width: 500px;"
            placeholder="请输入报告编号" 
            class="query-input"
          >
          <button @click="searchGet" class="query-btn">查询</button>
        </div>
      </div>
      <div v-if="isShow" class="result-wrapper">
        <div v-if="reqData.projectName" class="container">
          <div class="left-section">
            <div class="card">
              <img :src="`${$baseUrl}/evaluation/api/attachment/preview/${reqData.coverFileId}`" style="width: 100%;height: 100%;"/>
              <div class="card-mask">报告封面</div>
            </div>
            <div class="card">
              <img :src="`${$baseUrl}/evaluation/api/attachment/preview/${reqData.projectCertFileId}`" style="width: 100%;height: 100%;"/>
              <div class="card-mask">评价证书</div>
            </div>
          </div>
          <div class="right-section">
            <h1>{{reqData.projectName}}</h1>
            <p class="info-item">评价时间：{{reqData.updateTime}}</p>
            <p class="info-item">评价结果：{{reqData.evaluationConclusion || '暂无结果'}}</p>
          </div>
        </div>
        <div v-else class="empty-result">
          <p class="empty-title">查询结果</p>
          <p class="empty-desc">没有查询到相关结果，请确认查询信息无误!</p>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '../../components/Footer.vue';
import {evaluationReport} from '@/api/account'
export default {
  name: 'ReportQuery',
  data() {
    return {
      evaluationNumber: '',
      reqData:{},
      isShow:false,
    }
  },
  components: {
    Footer
  },
  methods: {
    searchGet(){
      evaluationReport({
        evaluationNumber:this.evaluationNumber,
      }).then((res)=>{
        if(res.code == 200){
          this.reqData = res.data;
          this.isShow = true;
        }else{
          this.isShow = true;
        }
      })
    }
  }
}
</script>

<style scoped>
.report-query-section {
  background: linear-gradient(135deg, #929eba 0%, #5e72b1 100%); 
  padding: 50px 0;
  position: relative;
  min-height: 600px;
}
.query-container {
  margin: 0 auto;
  text-align: center;
}
.query-title {
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 25px;
  letter-spacing: 1px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.15); 
}
.query-form {
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
}
.query-input {
  height: 48px;
  padding: 0 18px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  width: 280px;
  outline: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.query-input::placeholder {
  color: #b0c4de; 
}
.query-input:focus {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}
.query-btn {
  height: 48px;
  padding: 0 28px;
  background: #ffd700;
  color: #333;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 3px 6px rgba(255, 215, 0, 0.3);
  transition: all 0.3s ease;
}
.query-btn:hover {
  background: #ffc107;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(255, 215, 0, 0.4);
}
.query-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(255, 215, 0, 0.3);
}
@media (max-width: 576px) {
  .query-form {
    flex-direction: column;
    gap: 15px;
  }
  .query-input {
    width: 100%;
    max-width: 300px;
  }
  .query-btn {
    width: 100%;
    max-width: 300px;
  }
}
.result-wrapper {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  margin-top: 20px;
}
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1000px; 
  margin: 40px auto 60px;
  flex-wrap: wrap; 
  gap: 30px; 
}
.left-section {
  display: flex;
  gap: 24px;
  flex-wrap: wrap; 
  justify-content: center;
}

.card {
  width: 240px;
  height: 340px;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  border-radius: 4px;
  position: relative;
  overflow: hidden; 
}
.card-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
  top:0px;
  left: 0px;
}
.right-section {
  min-width: 280px;
  max-width: 400px; 
  color: #fff;
  text-align: center; 
}

.right-section h1 {
  font-size: 28px;
  margin-bottom: 32px;
  color: #fff; 
  word-break: break-all; 
  line-height: 1.4;
}

.info-item {
  font-size: 16px;
  margin-bottom: 12px;
  color: #fff; 
  line-height: 1.6;
}
.empty-result {
  margin: 40px auto;
  text-align: center;
  color: #fff;
  font-size: 24px;
  max-width: 80%; 
}

.empty-result .empty-title {
  color: #000;
  font-weight: bold;
  font-size: 32px;
  margin-bottom: 16px;
}
@media screen and (max-width: 768px) {
  .card {
    width: 200px;
    height: 300px; 
  }
  .right-section h1 {
    font-size: 24px;
    margin-bottom: 24px;
  }
  .info-item {
    font-size: 15px;
  }
  .empty-result {
    font-size: 20px;
  }
  .empty-result .empty-title {
    font-size: 28px;
  }
}
@media screen and (max-width: 480px) {
  .card {
    width: 160px;
    height: 240px; 
  }
  .card-mask {
    font-size: 16px; 
  }
  .right-section h1 {
    font-size: 22px;
    margin-bottom: 20px;
  }
  .info-item {
    font-size: 14px;
  }
  .empty-result {
    font-size: 18px;
  }
  .empty-result .empty-title {
    font-size: 24px;
  }
}
</style>